import {Button, createButtonComponent} from '@vfde-brix/button';
import {BUTTON_SELECT_OFFER_CONTAINER} from 'Constant';
import {scrollToAccordion} from 'Container/Landingpage/helpers/components/scrollHelper';

/**
 * Button BRIX component
 *
 * @param action - Pass the action
 */
export const mountSelectOfferButton = () => {

    const elButton = document.getElementById(BUTTON_SELECT_OFFER_CONTAINER);

    return createButtonComponent(elButton, {
        onClick: () => {
            return scrollToAccordion();
        },
    });

};

/**
 * Update Button depending on what the user has selected
 *
 * @param buttonComponent - Pass the button component
 * @param state - Pass the state
 */
export const updateOfferButton = (buttonComponent: Button, state ) => {

    // did the user optIn at least one "Ich habe bereits"
    const userHasSelected: boolean = state.has_mobilfunk || state.has_internet || state.has_tv || state.has_none;

    // did the user optIn at least one "Ich möchte"
    const userWantsSelected: boolean = state.wants_mobilfunk || state.wants_internet || state.wants_tv || state.wants_redplus;

    // only if at least one of each is selected, the button will be enabled
    const buttonDisabled = false === userHasSelected || false === userWantsSelected;

    // no button, when default notification is shown
    const hidden: boolean = state.default_notification_is_displayed;

    const buttonProperties = buttonComponent.getProperties();
    buttonProperties.hidden = hidden;
    buttonProperties.disabled = buttonDisabled;

    buttonComponent.update(buttonProperties);

};
